import { callApi } from './api';

import { Vehicle } from '@/types/vehicle';

export const updateVehicle = async (vehicleID: number, requestBody: Vehicle) => {
  const { status, result } = await callApi<Vehicle>(
    `vehicles/${vehicleID}`,
    'PUT',
    undefined,
    requestBody,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
